interface WordmarkProps {
  size?: number
  /** 'light' = white text (for dark backgrounds), 'dark' = near-black (default) */
  variant?: 'dark' | 'light'
}

export function Wordmark({ size = 22, variant = 'dark' }: WordmarkProps) {
  const color = variant === 'light' ? '#ffffff' : '#1f1a2e'
  const markSize = size * 1.35

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 9,
      fontFamily: '"Outfit", "Manrope", system-ui, sans-serif',
      fontWeight: 600,
      fontSize: size,
      letterSpacing: '-0.02em',
      color,
      lineHeight: 1,
    }}>
      <img
        src="/mark.svg"
        alt=""
        width={markSize}
        height={markSize}
        style={{ display: 'block', flexShrink: 0 }}
      />
      Fellowship
    </span>
  )
}
